import { 
  googleProperties, 
  isLoadingProperties, 
  propertyError,
  selectedPropertyId
} from '../state'
import { getProperties } from '../../../actions/google/methods/get-properties'

/**
 * Loads Google Analytics properties
 * @returns {Promise<Array>} List of Google Analytics properties
 */
export const loadGoogleProperties = async () => {
  isLoadingProperties.value = true
  propertyError.value = null
  
  try {
    const properties = await getProperties()
    googleProperties.value = properties
    
    return properties
  } catch (error) {
    propertyError.value = 'Mülkler yüklenirken bir hata oluştu. Lütfen tekrar deneyin.'
    googleProperties.value = []
    throw error
  } finally {
    isLoadingProperties.value = false
  }
}
